<div class="discount-group-offer-dialog" style="min-width: 520px; max-width: 640px">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">{{ isEdit ? 'Edit discount group offer' : 'Add discount group offer' }}</h5>
    <button type="button" class="btn btn-ghost-secondary btn-sm" (click)="cancel()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </div>

  <div class="multi-buy-offer-form">
    <div class="row g-2">
      <div class="col-12">
        <label class="form-label">Discount group</label>
        <ng-select
          [items]="groupOptions"
          bindLabel="discountGroup"
          placeholder="Search discount groups…"
          [typeahead]="groupSearchInput$"
          [loading]="groupsLoading"
          [(ngModel)]="selectedGroup"
          (change)="onGroupSelected($event)"
          [clearable]="!isEdit"
          [disabled]="isEdit"
          [minTermLength]="0">
          <ng-template ng-label-tmp let-item="item">
            {{ formatGroupLabel(item) }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div>{{ item.discountGroup }}</div>
            <small class="text-muted">{{ item.productCount ?? 0 }} product(s)</small>
          </ng-template>
        </ng-select>
        <div class="pricing-validation-slot">
          <div class="text-danger small" *ngIf="groupError">{{ groupError }}</div>
        </div>
        <small class="text-muted" *ngIf="isEdit">Group cannot be changed when editing an offer.</small>
      </div>

      <div class="col-12">
        <label class="form-label">Display name <span class="text-muted small">(optional)</span></label>
        <input type="text" class="form-control" [(ngModel)]="offerName" placeholder="Defaults to group name">
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">Required quantity</label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="offerRequiredQuantity"
          min="2"
          step="1"
          inputmode="numeric"
          placeholder="3"
          [class.is-invalid]="offerQtyError"
          (blur)="offerQtyTouched = true">
        <div class="pricing-validation-slot">
          <div class="text-danger small" *ngIf="offerQtyError">{{ offerQtyError }}</div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">Offer price (total)</label>
        <div class="input-group price-input-group">
          <input
            type="number"
            class="form-control"
            [(ngModel)]="offerPrice"
            min="0"
            step="0.01"
            inputmode="decimal"
            placeholder="10.00"
            [class.is-invalid]="offerPriceError"
            (blur)="offerPriceTouched = true">
          <span class="input-group-text">DKK</span>
        </div>
        <div class="pricing-validation-slot">
          <div class="text-danger small" *ngIf="offerPriceError">{{ offerPriceError }}</div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">Valid from <span class="text-muted small">(optional)</span></label>
        <input type="datetime-local" class="form-control" [(ngModel)]="offerValidFrom">
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">Valid to <span class="text-muted small">(optional)</span></label>
        <input type="datetime-local" class="form-control" [(ngModel)]="offerValidTo">
      </div>

      <div class="col-12">
        <label class="form-label d-flex align-items-center gap-2 mb-0">
          <input type="checkbox" class="form-check-input mt-0" [(ngModel)]="offerIsActive">
          Active
        </label>
      </div>
    </div>

    <div class="pricing-validation-slot">
      <div class="text-danger small" *ngIf="offerInlineError">{{ offerInlineError }}</div>
    </div>

    <div class="d-flex flex-wrap gap-2 mt-2">
      <button type="button" class="btn btn-primary" [disabled]="!canSubmitOffer() || offerSaving" (click)="saveOffer()">
        <span *ngIf="offerSaving" class="spinner-border spinner-border-sm me-1" role="status"></span>
        {{ isEdit ? 'Update offer' : 'Save offer' }}
      </button>
      <button type="button" class="btn btn-outline-secondary" [disabled]="offerSaving" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</div>
